import { Typography } from '@mui/material'

interface ChargingSessionMessageProps {
  message: string | React.ReactNode
}

const ChargingSessionMessage: React.FC<ChargingSessionMessageProps> = ({ message }) => {
  return (
    <Typography variant="subtitle2" textAlign="center" width="100%" fontWeight="medium">
      {message}
    </Typography>
  )
}

export default ChargingSessionMessage
